import { translate } from "@/plugins/i18n";
import BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";

export class EnumTaskRepeatBasis implements BaseEnumType {
  private static allValues: EnumTaskRepeatBasis[] = []; // make sure this is top-most
  
  public static none = new EnumTaskRepeatBasis(0, "None", "enum_task_repeat_basis_none");
  public static everyDay = new EnumTaskRepeatBasis(1, "EveryDay", "enum_task_repeat_basis_every_day");
  public static everyWeekday = new EnumTaskRepeatBasis(2, "EveryWeekday", "enum_task_repeat_basis_every_weekday");
  public static everyNWeeks = new EnumTaskRepeatBasis(3, "EveryNWeeks", "enum_task_repeat_basis_every_n_weeks");
  public static everyNMonths = new EnumTaskRepeatBasis(4, "EveryNMonths", "enum_task_repeat_basis_every_n_months");
  public static lastMatchingDayOfEachMonth = new EnumTaskRepeatBasis(5, "LastMatchingDayOfEachMonth", "enum_task_repeat_basis_last_matching_day_of_each_month");
  public static nthMatchingDayOfEachMonth = new EnumTaskRepeatBasis(6, "NthMatchingDayOfEachMonth", "enum_task_repeat_basis_nth_matching_day_of_each_month");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumTaskRepeatBasis.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumTaskRepeatBasis.none; }
  public isEveryDay() { return this === EnumTaskRepeatBasis.everyDay; }
  public isEveryWeekday() { return this === EnumTaskRepeatBasis.everyWeekday; }
  public isEveryNWeeks() { return this === EnumTaskRepeatBasis.everyNWeeks; }
  public isEveryNMonths() { return this === EnumTaskRepeatBasis.everyNMonths; }
  public isLastMatchingDayOfEachMonth() { return this === EnumTaskRepeatBasis.lastMatchingDayOfEachMonth; }
  public isNthMatchingDayOfEachMonth() { return this === EnumTaskRepeatBasis.nthMatchingDayOfEachMonth; }

  public static getValues(): readonly EnumTaskRepeatBasis[] {
    return EnumTaskRepeatBasis.allValues;
  }

  public static getValuesExcept0(): readonly EnumTaskRepeatBasis[] {
    return EnumTaskRepeatBasis.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumTaskRepeatBasis {
    const found = EnumTaskRepeatBasis.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumTaskRepeatBasis - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumTaskRepeatBasis): EnumTaskRepeatBasis {
    const found = name ? EnumTaskRepeatBasis.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumTaskRepeatBasis - Value not found: ${ name }`);
    }

    return found;
  }
}